import { call, select } from 'redux-saga/effects';
import { selectors as orderSelectors } from 'state/order';
import validateTimes from 'utils/dateAndTimes/validators/validateTimes';

function* asyncValidateTimes(times, shipmentKey) {
  const orderType = yield select(orderSelectors.getTypeOfOrder);
  const validations = yield select(orderSelectors.getValidations);
  const timeWindow = yield select(
    orderSelectors.getTimeWindowByShipmentKey,
    shipmentKey
  );
  const loadsInForm = yield select(
    orderSelectors.maxNumberOfItemsInLoadsBetweenShipments
  );

  const errors = yield call(
    validateTimes,
    times,
    loadsInForm,
    orderType,
    validations,
    timeWindow
  );
  return errors || {};
}

export default asyncValidateTimes;
